export const header = 'Διαχείριση Κλινικών';
